module.exports = __webpack_public_path__ + "img/internship.4a11b7be.svg";